// src/hooks/useSaveAnswer.js
import { ref, set, get, child } from "firebase/database";
import { auth, db } from "../services/firebase";

export default function useSaveAnswer(domainId, packId, interviewId) {
    const saveAnswer = async (question, index, text) => {
        const user = auth.currentUser;
        if (!user) throw new Error("User not authenticated");
        if (!question || !question.id) throw new Error("Invalid question");

        const testRef = ref(
            db,
            `Tests/Answers/${user.uid}/${domainId}/${packId}/${interviewId}/${question.id}`
        );

        // ✅ Save the exact orderId from InterviewQuestions
        const payload = {
            domainId,
            packId,
            interviewId,
            questionId: question.id,
            questionNumber: index + 1,
            orderId: question.orderId ?? 0, // 👈 This is now guaranteed from InterviewQuestions
            question: question.question || question.name || "",
            answer: (text || "").trim(),
            createdAt: Date.now(),
        };

        await set(testRef, payload);
    };

    const fetchLastAttemptIndex = async (questions) => {
        const user = auth.currentUser;
        if (!user) return 0;

        const testRef = child(
            ref(db),
            `Tests/Answers/${user.uid}/${domainId}/${packId}/${interviewId}`
        );
        const snapshot = await get(testRef);
        if (!snapshot.exists()) return 0;

        const data = snapshot.val();
        const answeredIds = Object.keys(data);
        const answeredCount = answeredIds.length;

        if (answeredCount >= questions.length) return 0; // restart if finished
        return answeredCount;
    };

    return { saveAnswer, fetchLastAttemptIndex };
}
